// ********* Jobs List CRUD Action Types *********

// Create New Job "Create"
export const ADD_NEW_JOB = "ADD_NEW_JOB";
export const ADD_JOB_SUCCESS = "ADD_JOB_SUCCESS";
export const ADD_JOB_FAIL = "ADD_JOB_FAIL";

// GET Job data "Read"
export const GET_JOBS_DATA = "GET_JOBS_DATA";
export const GET_JOBS_DATA_SUCCESS = "GET_JOBS_DATA_SUCCESS";
export const GET_JOBS_DATA_FAIL = "GET_JOBS_DATA_FAIL";

// Update Job "Update"
export const UPDATE_JOB = "UPDATE_JOB";
export const UPDATE_JOB_SUCCESS = "UPDATE_JOB_SUCCESS";
export const UPDATE_JOB_FAIL = "UPDATE_JOB_FAIL";

// Delete Job "Delete"
export const DELETE_JOB = "DELETE_JOB";
export const DELETE_JOB_SUCCESS = "DELETE_JOB_SUCCESS";
export const DELETE_JOB_FAIL = "DELETE_JOB_FAIL";

// ********* Jobs Status Action Types *********

// Create New Job Status "Create"
export const ADD_NEW_JOB_STATUS = "ADD_NEW_JOB_STATUS";
export const ADD_JOB_STATUS_SUCCESS = "ADD_JOB_STATUS_SUCCESS";
export const ADD_JOB_STATUS_FAIL = "ADD_JOB_STATUS_FAIL";

// GET Job Status data "Read"
export const GET_JOB_STATUS_DATA = "GET_JOB_STATUS_DATA";
export const GET_JOB_STATUS_DATA_SUCCESS = "GET_JOB_STATUS_DATA_SUCCESS";
export const GET_JOB_STATUS_DATA_FAIL = "GET_JOB_STATUS_DATA_FAIL";

// Update Job Status "Update"
export const UPDATE_JOB_STATUS = "UPDATE_JOB_STATUS";
export const UPDATE_JOB_STATUS_SUCCESS = "UPDATE_JOB_STATUS_SUCCESS";
export const UPDATE_JOB_STATUS_FAIL = "UPDATE_JOB_STATUS_FAIL";

// Delete Job Status "Delete"
export const DELETE_JOB_STATUS = "DELETE_JOB_STATUS";
export const DELETE_JOB_STATUS_SUCCESS = "DELETE_JOB_STATUS_SUCCESS";
export const DELETE_JOB_STATUS_FAIL = "DELETE_JOB_STATUS_FAIL";

/// ********* Single Job PDF get pdf sheet Action Types *********

// GET Single Job PDF data "Read"
export const GET_JOBS_PDF_DATA = "GET_JOBS_PDF_DATA";
export const GET_JOBS_PDF_DATA_SUCCESS = "GET_JOBS_PDF_DATA_SUCCESS";
export const GET_JOBS_PDF_DATA_FAIL = "GET_JOBS_PDF_DATA_FAIL";

// ********* Jobs Type Action Types *********

// Get Jobs Type list "Read"
export const GET_JOBS_TYPE_DATA = "GET_JOBS_TYPE_DATA";
export const GET_JOBS_TYPE_DATA_SUCCESS = "GET_JOBS_TYPE_DATA_SUCCESS";
export const GET_JOBS_TYPE_DATA_FAIL = "GET_JOBS_TYPE_DATA_FAIL";

// Create New Job Type "Create"
export const ADD_JOB_TYPE = "ADD_NEW_JOB_TYPE";
export const ADD_JOB_TYPE_SUCCESS = "ADD_JOB_TYPE_SUCCESS";
export const ADD_JOB_TYPE_FAIL = "ADD_JOB_TYPE_FAIL";

// Update Job Type "Update"
export const UPDATE_JOB_TYPE = "UPDATE_JOB_TYPE";
export const UPDATE_JOB_TYPE_SUCCESS = "UPDATE_JOB_TYPE_SUCCESS";
export const UPDATE_JOB_TYPE_FAIL = "UPDATE_JOB_TYPE_FAIL";

// Delete Job Type "Delete"
export const DELETE_JOB_TYPE = "DELETE_JOB_TYPE";
export const DELETE_JOB_TYPE_SUCCESS = "DELETE_JOB_TYPE_SUCCESS";
export const DELETE_JOB_TYPE_FAIL = "DELETE_JOB_TYPE_FAIL";

// ********* Jobs Priority List Action Types *********

// Get Jobs Priority list "Read"
export const GET_JOBS_PRIORITY_DATA = "GET_JOBS_PRIORITY_DATA";
export const GET_JOBS_PRIORITY_DATA_SUCCESS = "GET_JOBS_PRIORITY_DATA_SUCCESS";
export const GET_JOBS_PRIORITY_DATA_FAIL = "GET_JOBS_PRIORITY_DATA_FAIL";

// Create New Job Priority "Create"
export const ADD_JOB_PRIORITY = "ADD_NEW_JOB_PRIORITY";
export const ADD_JOB_PRIORITY_SUCCESS = "ADD_JOB_PRIORITY_SUCCESS";
export const ADD_JOB_PRIORITY_FAIL = "ADD_JOB_PRIORITY_FAIL";

// Update Job Priority "Update"
export const UPDATE_JOB_PRIORITY = "UPDATE_JOB_PRIORITY";
export const UPDATE_JOB_PRIORITY_SUCCESS = "UPDATE_JOB_PRIORITY_SUCCESS";
export const UPDATE_JOB_PRIORITY_FAIL = "UPDATE_JOB_PRIORITY_FAIL";

// Delete Job Priority "Delete"

export const DELETE_JOB_PRIORITY = "DELETE_JOB_PRIORITY";
export const DELETE_JOB_PRIORITY_SUCCESS = "DELETE_JOB_PRIORITY_SUCCESS";
export const DELETE_JOB_PRIORITY_FAIL = "DELETE_JOB_PRIORITY_FAIL";

// ********* Single Customer Jobs List search Action Types *********

// Get Single Customer Jobs List "Read"
export const GET_SINGLE_CUSTOMER_JOBS_LIST_DATA =
  "GET_SINGLE_CUSTOMER_JOBS_DATA";
export const GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_SUCCESS =
  "GET_SINGLE_CUSTOMER_JOBS_DATA_SUCCESS";
export const GET_SINGLE_CUSTOMER_JOBS_LIST_DATA_FAIL =
  "GET_SINGLE_CUSTOMER_JOBS_DATA_FAIL";

// Get Uninvoiced Jobs List
export const GET_UNINVOICED_JOBS_LIST_DATA = "GET_UNINVOICED_JOBS_DATA";
export const GET_UNINVOICED_JOBS_LIST_DATA_SUCCESS =
  "GET_UNINVOICED_JOBS_DATA_SUCCESS";
export const GET_UNINVOICED_JOBS_LIST_DATA_FAIL =
  "GET_UNINVOICED_JOBS_DATA_FAIL";
// Get Ready To Invoice Jobs List
export const GET_READY_TO_INVOICE_JOBS_LIST_DATA =
  "GET_READY_TO_INVOICE_JOBS_DATA";
export const GET_READY_TO_INVOICE_JOBS_LIST_DATA_SUCCESS =
  "GET_READY_TO_INVOICE_JOBS_DATA_SUCCESS";
export const GET_READY_TO_INVOICE_JOBS_LIST_DATA_FAIL =
  "GET_READY_TO_INVOICE_JOBS_DATA_FAIL";

// Job Convert to Invoice
export const CONVERT_JOB_TO_INVOICE = "CONVERT_JOB_TO_INVOICE";
export const CONVERT_JOB_TO_INVOICE_SUCCESS = "CONVERT_JOB_TO_INVOICE_SUCCESS";
export const CONVERT_JOB_TO_INVOICE_FAIL = "CONVERT_JOB_TO_INVOICE_FAIL";

// Recurring Job List
export const GET_RECURRING_JOBS_LIST_DATA = "GET_RECURRING_JOBS_DATA";
export const GET_RECURRING_JOBS_LIST_DATA_SUCCESS =
  "GET_RECURRING_JOBS_DATA_SUCCESS";
export const GET_RECURRING_JOBS_LIST_DATA_FAIL = "GET_RECURRING_JOBS_DATA_FAIL";

// Recurring Job Create
export const CREATE_RECURRING_JOB = "CREATE_RECURRING_JOB";
export const CREATE_RECURRING_JOB_SUCCESS = "CREATE_RECURRING_JOB_SUCCESS";
export const CREATE_RECURRING_JOB_FAIL = "CREATE_RECURRING_JOB_FAIL";

// Get Recurring Job Details
export const GET_RECURRING_JOB_DETAILS = "GET_RECURRING_JOB_DETAILS";
export const GET_RECURRING_JOB_DETAILS_SUCCESS =
  "GET_RECURRING_JOB_DETAILS_SUCCESS";
export const GET_RECURRING_JOB_DETAILS_FAIL = "GET_RECURRING_JOB_DETAILS_FAIL";

// Update Recurring Job

export const UPDATE_RECURRING_JOB = "UPDATE_RECURRING_JOB";
export const UPDATE_RECURRING_JOB_SUCCESS = "UPDATE_RECURRING_JOB_SUCCESS";
export const UPDATE_RECURRING_JOB_FAIL = "UPDATE_RECURRING_JOB_FAIL";

// Upload JobFiles and assign to Multiple Jobs
export const UPLOAD_JOB_FILES = "UPLOAD_JOB_FILES";
export const UPLOAD_JOB_FILES_SUCCESS = "UPLOAD_JOB_FILES_SUCCESS";
export const UPLOAD_JOB_FILES_FAIL = "UPLOAD_JOB_FILES_FAIL";

// Search Single job Receive list of files
export const SEARCH_SINGLE_JOB_FILES_LIST = "SEARCH_SINGLE_JOB_FILES_LIST";
export const SEARCH_SINGLE_JOB_FILES_LIST_SUCCESS =
  "SEARCH_SINGLE_JOB_FILES_LIST_SUCCESS";
export const SEARCH_SINGLE_JOB_FILES_LIST_FAIL =
  "SEARCH_SINGLE_JOB_FILES_LIST_FAIL";

// Delete Single Job File
export const DELETE_SINGLE_JOB_FILE = "DELETE_SINGLE_JOB_FILE";
export const DELETE_SINGLE_JOB_FILE_SUCCESS = "DELETE_SINGLE_JOB_FILE_SUCCESS";
export const DELETE_SINGLE_JOB_FILE_FAIL = "DELETE_SINGLE_JOB_FILE_FAIL";

// Update File Attachment
export const UPDATE_FILE_ATTACHMENT = "UPDATE_FILE_ATTACHMENT";
export const UPDATE_FILE_ATTACHMENT_SUCCESS = "UPDATE_FILE_ATTACHMENT_SUCCESS";
export const UPDATE_FILE_ATTACHMENT_FAIL = "UPDATE_FILE_ATTACHMENT_FAIL";

// JobSearch List Get Request
export const GET_JOB_SEARCH_LIST_DATA = "GET_JOB_SEARCH_LIST_DATA";
export const GET_JOB_SEARCH_LIST_DATA_SUCCESS =
  "GET_JOB_SEARCH_LIST_DATA_SUCCESS";
export const GET_JOB_SEARCH_LIST_DATA_FAIL = "GET_JOB_SEARCH_LIST_DATA_FAIL";

// JobsList Jobs Open List
export const GET_JOBS_OPEN_LIST_DATA = "GET_JOBS_OPEN_LIST_DATA";
export const GET_JOBS_OPEN_LIST_DATA_SUCCESS =
  "GET_JOBS_OPEN_LIST_DATA_SUCCESS";
export const GET_JOBS_OPEN_LIST_DATA_FAIL = "GET_JOBS_OPEN_LIST_DATA_FAIL";

//mark job as completed
export const MARK_JOB_AS_COMPLETED = "MARK_JOB_AS_COMPLETED";
export const MARK_JOB_AS_COMPLETED_SUCCESS = "MARK_JOB_AS_COMPLETED_SUCCESS";
export const MARK_JOB_AS_COMPLETED_FAIL = "MARK_JOB_AS_COMPLETED_FAIL";

///job/converttoproformainvoice
export const CONVERT_JOB_TO_PROFORMA_INVOICE =
  "CONVERT_JOB_TO_PROFORMA_INVOICE";
export const CONVERT_JOB_TO_PROFORMA_INVOICE_SUCCESS =
  "CONVERT_JOB_TO_PROFORMA_INVOICE_SUCCESS";
export const CONVERT_JOB_TO_PROFORMA_INVOICE_FAIL =
  "CONVERT_JOB_TO_PROFORMA_INVOICE_FAIL";

///job/invoices_by_job — invoices + proformas raised against a single job
export const GET_INVOICES_BY_JOB = "GET_INVOICES_BY_JOB";
export const GET_INVOICES_BY_JOB_SUCCESS = "GET_INVOICES_BY_JOB_SUCCESS";
export const GET_INVOICES_BY_JOB_FAIL = "GET_INVOICES_BY_JOB_FAIL";

// Predicted billable item: mark / unmark manually billed (no invoice)
export const PREDICTED_MARK_BILLED = "PREDICTED_MARK_BILLED";
export const PREDICTED_MARK_BILLED_SUCCESS = "PREDICTED_MARK_BILLED_SUCCESS";
export const PREDICTED_MARK_BILLED_FAIL = "PREDICTED_MARK_BILLED_FAIL";

// Predicted billable item: link to an existing invoice line item
export const PREDICTED_LINK_TO_INVOICEITEM = "PREDICTED_LINK_TO_INVOICEITEM";
export const PREDICTED_LINK_TO_INVOICEITEM_SUCCESS =
  "PREDICTED_LINK_TO_INVOICEITEM_SUCCESS";
export const PREDICTED_LINK_TO_INVOICEITEM_FAIL =
  "PREDICTED_LINK_TO_INVOICEITEM_FAIL";
